var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFavorites(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 21,
    viewBox: "0 0 24 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.84 2.61183C20.3292 2.10083 19.7228 1.69547 19.0554 1.41891C18.3879 1.14235 17.6725 1 16.95 1C16.2275 1 15.5121 1.14235 14.8446 1.41891C14.1772 1.69547 13.5708 2.10083 13.06 2.61183L12 3.67183L10.94 2.61183C9.9083 1.58013 8.50903 1.00053 7.05 1.00053C5.59096 1.00053 4.19169 1.58013 3.16 2.61183C2.1283 3.64352 1.54871 5.04279 1.54871 6.50183C1.54871 7.96086 2.1283 9.36013 3.16 10.3918L4.22 11.4518L12 19.2318L19.78 11.4518L20.84 10.3918C21.351 9.88107 21.7563 9.27464 22.0329 8.60718C22.3095 7.93972 22.4518 7.22431 22.4518 6.50183C22.4518 5.77934 22.3095 5.06393 22.0329 4.39647C21.7563 3.72901 21.351 3.12258 20.84 2.61183Z",
    stroke: "#091F82",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFavorites);
export default __webpack_public_path__ + "static/media/Favorites.486265c05e8522d87d5c2b5c1ff8e53d.svg";
export { ForwardRef as ReactComponent };